var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{pre:true,attrs:{"d":"M12 2.5 20 7l-8 4.5L4 7Z"}}),_c('path',{pre:true,attrs:{"opacity":".7","d":"M3.5 8.6 11.3 13v8.6l-7.8-4.4Z"}}),_c('path',{pre:true,attrs:{"opacity":".45","d":"M20.5 8.6 12.7 13v8.6l7.8-4.4Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }